import { render } from "./lighthouse-report.vue?vue&type=template&id=137f474d"
import script from "./lighthouse-report.vue?vue&type=script&lang=js"
export * from "./lighthouse-report.vue?vue&type=script&lang=js"

import "./lighthouse-report.vue?vue&type=style&index=0&id=137f474d&lang=css"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__